/**
 * Tools for accessing Convex in the browser.
 *
 * **If you are using React, use the {@link react} module instead.**
 *
 * ## Usage
 *
 * Create a {@link ConvexHttpClient} to connect to the Convex Cloud.
 *
 * ```typescript
 * import { ConvexHttpClient } from "convex/browser";
 * import clientConfig from "../convex/_generated/clientConfig";
 * const convex = new ConvexHttpClient(clientConfig);
 * ```
 *
 * @module
 */
export { InternalConvexClient } from "./sync/client.js";
export type { ClientOptions } from "./sync/client.js";
export type {
  OptimisticUpdate,
  OptimisticLocalStore,
} from "./sync/optimistic_query_set.js";
export type { QueryResult } from "./sync/remote_query_set.js";
export type { QueryToken } from "./sync/udf_path_utils.js";
export { ConvexHttpClient } from "./http_client.js";
export type { Query, Mutation } from "./http_client.js";
export * from "./api.js";
export type { ClientConfiguration } from "./client_config";
